var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.9999 36.6667C29.2047 36.6667 36.6666 29.2047 36.6666 20C36.6666 10.7952 29.2047 3.33331 19.9999 3.33331C10.7952 3.33331 3.33325 10.7952 3.33325 20C3.33325 29.2047 10.7952 36.6667 19.9999 36.6667Z",
    fill: "#141B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 36.6667C29.2047 36.6667 36.6666 29.2047 36.6666 20C36.6666 10.7952 29.2047 3.33331 19.9999 3.33331C10.7952 3.33331 3.33325 10.7952 3.33325 20C3.33325 29.2047 10.7952 36.6667 19.9999 36.6667Z",
    fill: "white",
    stroke: "#E5E5E5",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 20.0003H13.9998",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusSign);
export default __webpack_public_path__ + "static/media/minus-sign.0e16a677489369792f9dfd3d0165d4fd.svg";
export { ForwardRef as ReactComponent };